import { useEffect, useState } from "react";
import { RefreshCw, Sparkles } from "lucide-react";

const CURRENT_VERSION = __APP_VERSION__;

// Polling toutes les 2 min + reveil au focus onglet.
const POLL_INTERVAL_MS = 2 * 60 * 1000;

async function fetchServerVersion(): Promise<string | null> {
  try {
    const res = await fetch("/version.json", {
      cache: "no-store",
      headers: { "Cache-Control": "no-cache" },
    });
    if (!res.ok) return null;
    const json = (await res.json()) as { version?: string };
    return json.version ?? null;
  } catch {
    return null;
  }
}

export function UpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const remote = await fetchServerVersion();
      if (cancelled || !remote) return;
      if (remote !== CURRENT_VERSION) {
        setUpdateAvailable(true);
      }
    };

    // First check delayed a bit to let the app boot
    const kickoff = window.setTimeout(check, 10_000);
    const interval = window.setInterval(check, POLL_INTERVAL_MS);

    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", check);

    return () => {
      cancelled = true;
      window.clearTimeout(kickoff);
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", check);
    };
  }, []);

  if (!updateAvailable) return null;

  const reload = () => {
    // Purge le cache SW s'il existe puis reload hard.
    if ("caches" in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
    window.location.reload();
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-brand-600 to-brand-700 text-white shadow-lg"
      role="alert"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-3 flex items-center gap-3 flex-wrap">
        <div className="shrink-0 w-8 h-8 rounded-full bg-white/15 flex items-center justify-center">
          <Sparkles size={16} className="text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-bold text-sm">Nouvelle version disponible</div>
          <div className="text-xs opacity-90">
            Mettez à jour maintenant pour bénéficier des dernières améliorations.
          </div>
        </div>
        <button
          onClick={reload}
          className="shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-white text-brand-700 hover:bg-brand-50 text-sm font-bold transition-colors"
        >
          <RefreshCw size={14} />
          Mettre à jour
        </button>
      </div>
    </div>
  );
}
